import { Command } from 'commander';
import { ApiClient } from '../client.js';
import { formatOutput } from '../output.js';
import { parseData, getBase, getFormat } from '../helpers.js';
import { confirm } from '../prompt.js';

export const fileTypesCommand = new Command('file-types')
  .description('Manage file types (Buckets) — storage policy + optional metadata schema for files');

fileTypesCommand.command('list')
  .description('List all file types in a database')
  .action(async function (this: Command) {
    const ws = getBase(this);
    const client = new ApiClient();
    const data = await client.request('GET', `/v1/${ws}/file-types`);
    console.log(formatOutput(data, getFormat(this)));
  });

fileTypesCommand.command('get <id>')
  .description('Get a file type')
  .action(async function (this: Command, id: string) {
    const ws = getBase(this);
    const client = new ApiClient();
    const data = await client.request('GET', `/v1/${ws}/file-types/${id}`);
    console.log(formatOutput(data, getFormat(this)));
  });

fileTypesCommand.command('upsert <id>')
  .description('Create or update a file type (preview databases only)')
  .requiredOption('--name <name>', 'File type name')
  .option('--description <desc>', 'Description')
  .option('--max-size <bytes>', 'Max bytes per file (0 = unlimited)')
  .option('--allowed-content-types <json>', 'Allowed content-types, JSON array (inline or @filename)')
  .option('--metadata-schema <json>', 'JSON Schema for file metadata (inline JSON or @filename)')
  .action(async function (this: Command, id: string, opts: { name: string; description?: string; maxSize?: string; allowedContentTypes?: string; metadataSchema?: string }) {
    const ws = getBase(this);
    const client = new ApiClient();
    const body: Record<string, unknown> = { name: opts.name };
    if (opts.description) body['description'] = opts.description;
    if (opts.maxSize) body['max_size'] = Number(opts.maxSize);
    if (opts.allowedContentTypes) body['allowed_content_types'] = parseData(opts.allowedContentTypes);
    if (opts.metadataSchema) body['metadata_schema'] = parseData(opts.metadataSchema);
    const data = await client.request('PUT', `/v1/${ws}/file-types/${id}`, body);
    console.log(formatOutput(data, getFormat(this)));
  });

fileTypesCommand.command('delete <id>')
  .description('Delete a file type (cascades its files)')
  .option('-y, --yes', 'Skip confirmation prompt')
  .action(async function (this: Command, id: string, opts: { yes?: boolean }) {
    if (!opts.yes && !(await confirm(`Delete file type "${id}"? This cascades its files and cannot be undone.`))) {
      console.log('Aborted');
      return;
    }
    const ws = getBase(this);
    const client = new ApiClient();
    await client.request('DELETE', `/v1/${ws}/file-types/${id}`);
    console.log('Deleted');
  });
